<script setup lang="ts">
import Loading from '@shell/components/Loading.vue';

interface Props {
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), { loading: false });

</script>

<template>
  <div
    class="resource-detail-page"
  >
    <Loading v-if="props.loading" />
    <template v-else>
      <div
        v-if="$slots['top-area']"
        class="top-area"
      >
        <slot name="top-area" />
      </div>
      <div
        v-if="$slots['middle-area']"
        class="middle-area mmt-6"
      >
        <slot name="middle-area" />
      </div>
      <div
        v-if="$slots['bottom-area']"
        class="bottom-area mmt-6"
      >
        <slot name="bottom-area" />
      </div>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.resource-detail-page {
  min-width: 0;
  color: var(--dev-ink, var(--body-text));

  .top-area, .middle-area, .bottom-area { min-width: 0; }
  .middle-area, .bottom-area { margin-top: 24px; }

  :deep(.tabs.horizontal) {
    border: none;
    background: var(--dev-surface, var(--body-bg));
    padding: 0 8px;
  }

  :deep(.tabs.horizontal + .tab-container) {
    border: none;
    border-top: 1px solid var(--dev-border, var(--border));
    padding: 20px;
  }

  :deep(.tabbed-container:not(.side-tabs)) {
    min-width: 0;
    border: 1px solid var(--dev-border, var(--border));
    border-radius: 8px;
    background: var(--dev-surface, var(--body-bg));
  }
}

@media (max-width: 600px) {
  .resource-detail-page {
    .middle-area, .bottom-area { margin-top: 16px; }
    :deep(.tabs.horizontal + .tab-container) { padding: 16px; }
  }
}
</style>
